import React from 'react';
import { Layers, Droplets, Hammer, Shield, Grid, Thermometer } from 'lucide-react';
import { Card, CardContent } from '../ui/Card';
export function LongevitySection() {
  const factors = [{
    icon: Layers,
    title: 'Base Preparation',
    desc: 'Proper gravel depth, compaction, and grading'
  }, {
    icon: Droplets,
    title: 'Drainage',
    desc: 'Water must flow away from the surface, not pool'
  }, {
    icon: Hammer,
    title: 'Compaction',
    desc: 'Every layer compacted to spec prevents settling'
  }, {
    icon: Grid,
    title: 'Edge Restraints',
    desc: 'Critical for pavers—prevents spreading and shifting'
  }, {
    icon: Shield,
    title: 'Reinforcement',
    desc: 'Rebar, mesh, or fiber for concrete; proper bedding for pavers'
  }, {
    icon: Thermometer,
    title: 'Sealing & Salt Habits',
    desc: 'Right sealer + minimal salt = maximum lifespan'
  }];
  return <section className="py-16 bg-slate-900 text-white md:py-24" data-id="element-596">
      <div className="container mx-auto px-4 md:px-6" data-id="element-597">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-598">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl" data-id="element-599">
            What Actually Drives Longevity
          </h2>
          <p className="mt-4 text-lg text-slate-300" data-id="element-600">
            The material is only as good as what is underneath.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-601">
          {factors.map((factor, index) => <Card key={index} className="bg-slate-800 border-slate-700 text-white hover:bg-slate-750 transition-colors" data-id="element-602">
              <CardContent className="p-6" data-id="element-603">
                <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center mb-4 text-primary-foreground border border-primary/30" data-id="element-604">
                  <factor.icon className="h-6 w-6" data-id="element-605" />
                </div>
                <h3 className="font-bold text-lg mb-2" data-id="element-606">{factor.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed" data-id="element-607">
                  {factor.desc}
                </p>
              </CardContent>
            </Card>)}
        </div>

        <div className="bg-primary/10 border border-primary/20 rounded-xl p-6 max-w-3xl mx-auto text-center" data-id="element-608">
          <p className="text-lg font-medium text-primary-foreground" data-id="element-609">
            "We focus on these fundamentals because no material can overcome a
            bad base. A $15/sq ft concrete driveway on a proper base outlasts a
            $40/sq ft stone patio on a rushed one."
          </p>
        </div>
      </div>
    </section>;
}